module.exports = __webpack_public_path__ + "img/banner-normal.936a32cd.png";